<template>
  <div
    class="advanced-search-container"
    v-if="show"
    v-show="visible"
  >
    <div class="slot-container">
      <slot></slot>
    </div>
    <div class="advanced-footer">
      <div class="button-group">
        <el-button @click="clear">{{ $t('Common.com_clear') }}</el-button>
        <el-button
          type="primary"
          @click="search"
        >
          {{
          $t('Common.com_query')
          }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      show: false,
      visible: true,
    };
  },
  methods: {
    open() {
      this.show = true;
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    search() {
      this.$emit('search');
    },
    clear() {
      this.$emit('clear');
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.advanced-search-container {
  padding: 0px 8px 8px;
  margin-bottom: 16px;
  background: #f6f6fa;
  border-radius: 2px;
  overflow: hidden;
  > .slot-container {
    overflow: hidden;

    .el-form-item {
      width: 25%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
  }
  > .advanced-footer {
    overflow: hidden;
    .button-group {
      margin-right: 8px;
      margin-bottom: 8px;
      margin-top: 8px;
      float: right;
    }
  }

  .el-input-group__prepend {
    background-color: #ffffff;
    border: none;
    .el-select {
      vertical-align: baseline !important;
    }
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #fcfcfc;
  }

  .el-form-item--small .el-form-item__label {
    margin-top: 16px;
    font-size: 12px;
    padding: 0px 0px 4px 0 !important;
    color: #495057;
    line-height: 24px;
  }
  .el-date-editor.el-input {
    width: 100% !important;
  }
}
</style>
